import { render, staticRenderFns } from "./SupplierRegister.vue?vue&type=template&id=98c2ed70&scoped=true&"
import script from "./SupplierRegister.vue?vue&type=script&lang=js&"
export * from "./SupplierRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c2ed70",
  null
  
)

export default component.exports